import axios from "axios";
import env from "../env";

const BASE_URL = env.baseURL;

class UserApi {
  static getUserInfo = () => {
    const url = `${BASE_URL}/user/userInfo`;
    return axios.get(url).then((response) => response.data);
  };

  static getAllUsers = () => {
    const url = `${BASE_URL}/user/all`;
    return axios.get(url).then((response) => response.data);
  };

  static saveUser = (user) => {
    const url = `${BASE_URL}/user`;
    return axios.post(url, user).then((response) => response.data);
  };
}

export default UserApi;
